<template>
  <div>
    <h4 class="font-weight-bold pa-3 text-capitalize mb-0">
      {{ companyEmployee.company.name.toLowerCase() }}

      <v-tooltip
        bottom
        min-width="250"
      >
        <template v-slot:activator="{ on: tooltip }">
          <v-icon
            small
            color="info"
            v-on="{ ...tooltip }"
          >
            mdi-information-outline
          </v-icon>
        </template>
        <div>Created by: <b>{{ companyEmployee.created_by }}</b> on <b>{{ $moment(companyEmployee.created_at).format('DD-MM-YYYY') }}</b></div>
        <div>Updated by: <b>{{ companyEmployee.updated_by }}</b> on <b>{{ $moment(companyEmployee.updated_at).format('DD-MM-YYYY') }}</b></div>
      </v-tooltip>

      <employee-profile-payroll-payroll-company-company-dialog-delete
        v-if="companyEmployee.payroll_cycle_employees_count < 1 && !isResigned"
        :company-employee="companyEmployee"
        @deleted="$emit('deleted')"
      />
      <span
        v-else
        class="font-weight-thin caption font-italic pl-2 red--text"
      >Payroll Company cannot be deleted due to computed payroll</span>
    </h4>

    <v-row class="mx-0">
      <v-col
        cols="6"
        class="py-0"
      >
        <span class="font-weight-medium">Start Date:</span>
        <span class="pl-3">{{ $moment(companyEmployee.start_date ).format('D MMM YYYY') }}</span> 
      </v-col>

      <v-col
        cols="6"
        class="py-0"
      >
        <span class="font-weight-medium">End Date:</span>
        <span class="pl-3">{{ companyEmployee.end_date? $moment(companyEmployee.end_date ).format('D MMM YYYY'):'N/A' }}</span>
        <employee-profile-payroll-payroll-company-company-dialog-edit
          v-if="$hasPermissionTo(['update employee payroll']) && !isResigned"
          :company-employee="companyEmployee"
          @updated="$emit('load')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollPayrollCompanyCompanyDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/company/DialogEdit'),
      EmployeeProfilePayrollPayrollCompanyCompanyDialogDelete: () => import('@/components/hris/employee/profile/payroll/payroll-company/company/DialogDelete'),
    },
    props: {
      companyEmployee: {
        type: Object,
        default: null,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
  }
</script>

<style scoped>
.caption{
  font-size: x-small;
}
</style>
